up.compiler('[data-subjects-list-toggle]', (toggle: HTMLButtonElement) => {
  const list = toggle.previousElementSibling as HTMLElement

  up.on(toggle, 'click', () => {
    list.classList.add('-expanded')
  })
})
